import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';
const Profile = () => {
    return (
        <Box p={5} shadow="md" borderWidth="1px">
            <Heading fontSize="xl">nutteiのポートフォリオサイト</Heading>
            <Text mt={4}>自身のブログや開発についての成果物を掲載していきます。</Text>
        </Box>
    );
};

    export default Profile;
